/* eslint-disable eqeqeq */
export const hex2rgba = (hex = '', opacity = 1) => {
  hex = (`${hex}`).trim();

  const rgb = {
    a: opacity,
  };

  const match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

  if (!hex || !match) {
    return {};
  }

  [ , hex ] = match;

  // check if 6 letters are provided
  if (hex.length == 6) {
    rgb.r = parseInt(hex.substring(0, 2), 16);
    rgb.g = parseInt(hex.substring(2, 4), 16);
    rgb.b = parseInt(hex.substring(4, 6), 16);
  } else if (hex.length == 3) {
    rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
    rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
    rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
  }

  rgb.css = `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`;

  return rgb;
};
/**
This function enables blending of colors, in case you need to darken or lighten a configuration color, for example.
Usage example:
* First turn the config color to rgba, with or without opacity:
const bg_color_rgba = hex2rgba(this.props.lobby_skin_config.main_color, 0.8);
* Then mix the colors by passing an array of colors to blend:
const bg_hover_color = blendColors([[bg_color_rgba.r, bg_color_rgba.g, bg_color_rgba.b, bg_color_rgba.a], [255,255,255,0.15]]);
*/
export const blendColors = (colors) => {
  let base = [ 0, 0, 0, 0 ];
  let mix;
  let added;
  // eslint-disable-next-line no-cond-assign
  while ((added = colors.shift())) {
    if (typeof added[3] === 'undefined') {
      added[3] = 1;
    }
    // check if both alpha channels exist.
    if (base[3] && added[3]) {
      mix = [ 0, 0, 0, 0 ];
      // alpha
      mix[3] = 1 - (1 - added[3]) * (1 - base[3]);
      // red
      mix[0] = Math.round(
        (added[0] * added[3]) / mix[3]
          + (base[0] * base[3] * (1 - added[3])) / mix[3],
      );
      // green
      mix[1] = Math.round(
        (added[1] * added[3]) / mix[3]
          + (base[1] * base[3] * (1 - added[3])) / mix[3],
      );
      // blue
      mix[2] = Math.round(
        (added[2] * added[3]) / mix[3]
          + (base[2] * base[3] * (1 - added[3])) / mix[3],
      );
    } else if (added) {
      mix = added;
    } else {
      mix = base;
    }
    base = mix;
  }

  const rgb = {
    r: mix[0],
    g: mix[1],
    b: mix[2],
    a: mix[3],
  };

  rgb.css = `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`;

  return rgb;
};

/**
  The parameters should be pairs of hex color and opacity.
  The returned value is an object with fields for r,g,b, and a of the new color, and also a css field for convenience.
  Example:
      const new_color = blendHexColors([0xffffff, 0,1], [0x111111, 0.5]);
*/
export function blendHexColors(...pairs) {
  return pairs.reduce((acc, [ initialColor, opacity ]) => {
    const color = hex2rgba(initialColor, opacity);

    return acc
      ? blendColors([
        [ acc.r, acc.g, acc.b, acc.a ],
        [ color.r, color.g, color.b, color.a ],
      ])
      : color;
  }, '');
}
